// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/jne6owq.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-top-nav[data-v-7d24ba4e]{background:linear-gradient(135deg,#ffe543 .13%,#ffcd19 100.13%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
